var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90845 6.48335V14.5917C1.90845 16.175 3.03345 16.825 4.40011 16.0417L6.35845 14.925C6.78345 14.6834 7.49178 14.6584 7.93345 14.8834L12.3084 17.075C12.7501 17.2917 13.4584 17.275 13.8834 17.0334L17.4918 14.9667C17.9501 14.7 18.3334 14.05 18.3334 13.5167V5.40835C18.3334 3.82502 17.2084 3.17502 15.8418 3.95835L13.8834 5.07502C13.4584 5.31669 12.7501 5.34169 12.3084 5.11669L7.93345 2.93335C7.49178 2.71669 6.78345 2.73335 6.35845 2.97502L2.75011 5.04169C2.28345 5.30835 1.90845 5.95835 1.90845 6.48335Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1333 3.33337V14.1667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1084 5.51672V16.6667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.4944a5f8b091b4c98140d568cf8802c5.svg";
export { ForwardRef as ReactComponent };